module.exports = "/_next/static/images/modelsfooter-152ff4ec8fbc5a4be915054d0ae99897.jpg";